import { render, staticRenderFns } from "./boleto2.vue?vue&type=template&id=22eb74d9&scoped=true"
import script from "./boleto2.vue?vue&type=script&lang=js"
export * from "./boleto2.vue?vue&type=script&lang=js"
import style0 from "./boleto2.vue?vue&type=style&index=0&id=22eb74d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb74d9",
  null
  
)

export default component.exports